const dataFA = [
    {
        CD_PRODUTO: 2409,
        NM_PRODUTO: 'Rastreador Ituran Assist'
    },
    {
        CD_PRODUTO: 2431,
        NM_PRODUTO: 'Rastreador Ituran Assist Moto',
    },
    {
        CD_PRODUTO: 2207,
        NM_PRODUTO: 'Rastreador Regional RF + Assistência',
    },
    {
        CD_PRODUTO: 2111,
        NM_PRODUTO: 'Combo: Rastreador Nacional + Assistência + Monitoramento',
    },
    {
        CD_PRODUTO: 2208,
        NM_PRODUTO: 'Combo: Rastreador Nacional + Assistência + Monitoramento',
    }
]

export const handleSomeProductFA = (CD_PRODUTO_SELECTED: number) => dataFA.some(({ CD_PRODUTO }) => CD_PRODUTO === CD_PRODUTO_SELECTED);